export default "<m4u-messageboxdialog #messageDialog *ngIf=\"isMessageDialogInDOM\"></m4u-messageboxdialog>";